import { createContext, useContext } from "react";

import {
  TypographyBodySize,
  TypographyLineHeight
} from "../styles/typography/typography";

export type TypographyContext = {
  typographyBodySize?: TypographyBodySize;
  lineHeight?: TypographyLineHeight;
};

const typographyContext = createContext<TypographyContext>({});

export const TypographyProvider = typographyContext.Provider;

export const useTypography = () => useContext(typographyContext);
